import React, { useState, useEffect, useRef } from "react";
import "./Workbench.css";

function BacktradeOptions() {
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);
  const backtradeOptions = ["SMA", "MACD", "RSA", "Bollinger Bands", "EMA", "Ichimoku Cloud", "ADX", "Fibonacci Retracement", "VWAP"];

  const toggleOptions = () => {
    setShowOptions((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ position: "relative" }} ref={dropdownRef}>
      <button
        className="p-1 border border-white text-center rounded-pill" style={{width: "100%"}}
        onClick={toggleOptions}
      >
        Technical Analysis
      </button>
      <div
        className={`backtrade-options-box ${
          showOptions ? "dropdown-show" : "dropdown-hide"
        }`}
      >
        <ul className="options-list">
          {backtradeOptions.map((option, index) => (
            <li
              key={index}
              className="option-item"
              onClick={() => {
                alert(`You selected ${option}`);
                setShowOptions(false); // Close dropdown after selection
              }}
            >
              {option}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default BacktradeOptions;
